import { render, staticRenderFns } from "./header-comp.vue?vue&type=template&id=566ef450&scoped=true&"
import script from "./header-comp.vue?vue&type=script&lang=js&"
export * from "./header-comp.vue?vue&type=script&lang=js&"
import style0 from "./header-comp.vue?vue&type=style&index=0&id=566ef450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ef450",
  null
  
)

export default component.exports